import React, { useState } from "react";
import avatar from "../../Assets/svg/avatar-img.svg";
import "./connect.scss";
import loc from "../../Assets/svg/location.svg";
import phone from "../../Assets/svg/phone grey.svg";
import mail from "../../Assets/svg/mail grey.svg";
import ItemTab from "../modules/ItemTabs";
import PersonalProfile from "../Connect/personalProfile";
import EduProfile from "../Connect/EduProfile";
import ProfessionalProfile from "../Connect/ProfessionalProfile";
import { useSelector } from "react-redux";

function AlumniProfile() {
  const [tab, setTab] = useState("Personal Details");
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  return (
    <div className="form-div connect-page alumni-profile">
      <div className="form-title">Profile</div>

      <div className="profile-top">
        <div className="profile-picture">
          {tokenData?.docs?.profilePicture?.fileBlob &&
            docs?.profilePicture?.fileType && (
              <img
                className="image"
                src={
                  "data:image/" +
                  docs?.profilePicture?.fileType +
                  ";base64," +
                  docs?.profilePicture?.fileBlob
                }
                alt="Preview"
                style={{ maxWidth: "100%", height: "100%" }}
              />
            )}
          {/* <img src={avatar} alt="avatar" /> */}
        </div>
        <div className="md-title">{personalInfo?.firstName}</div>
        <div className="border-line" />
        <div className="college-line">
          <div className="role-text">
            College
            <span>{tokenData?.registrationData.college}</span>
          </div>
          <div className="role-text">
            Batch
            <span>{tokenData?.registrationData?.year}</span>
          </div>
        </div>
        <div className="college-line">
          <div className="role-text">
            Company
            <span>{personalInfo?.company}</span>
          </div>
          <div className="role-text">
            Work Experience
            <span>{personalInfo?.exp2}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlumniProfile;
